import {
  extLinkMyPostDelegationUI,
  extLnkInvalidID,
  extLnkNotTrackableFAQ,
  extLnkOwnershipFAQ,
  extLnkPostOfficeLocator,
} from 'config/track-config';

export const errorContent = {
  generic: `Something's gone wrong at our end. Please try again later.`,
  notTrackableTrackingId:
    "This parcel can't be tracked. It may have been sent using a delivery service that doesn't include tracking. " +
    `<a href="${extLnkNotTrackableFAQ}" target="_blank">Learn more</a>`,
  serverError: `We're having trouble connecting right now. It looks like a temporary issue, so please try again later.`,
  unauthorisedKnownToken: `You're logged in as a different user. Please log out and access your tracking email again.`,
  nicknameError: `We couldn't save the name you entered. Remove any special characters, or try this again later.`,
  articleSubscriptionError: `We couldn't change your notification preference for this parcel. It's a temporary connection problem, so please try again later.`,
  notTrackable: (trackingIds: string[]) => {
    const trackingIdStr =
      trackingIds.length === 1
        ? `<strong>${trackingIds[0]}</strong> is`
        : `<strong>${trackingIds.join(', ')}</strong> are`;
    return `Sorry, ${trackingIdStr} not trackable. <a href="${extLnkNotTrackableFAQ}" target="_blank">What does this mean?</a>`;
  },
  invalidTrackingId: (trackingIds: string[]) => {
    if (trackingIds.length === 1)
      return `<div><strong>We couldn't find that tracking number</strong></div> Tracking number <strong>${trackingIds[0]}</strong> might be incorrect or not in our system yet.
      It can take a while to show up here, so check back later. <a href="${extLnkInvalidID}" target="_blank">Learn&nbsp;more</a>`;
    return `<div><strong>We couldn't find your tracking numbers</strong></div> Tracking numbers <strong>${trackingIds.join(
      ', '
    )}</strong> might be incorrect or not in our system yet. It can take a while to show up here, so check back later. <a href="${extLnkInvalidID}" target="_blank">Learn&nbsp;more</a>`;
  },
  alreadyAdded: (trackingIds: string[]) => {
    if (trackingIds.length === 1) return `<strong>${trackingIds[0]}</strong> is already added to your track list`;
    return `<strong>${trackingIds.slice(0, trackingIds.length - 1).join(', ')}</strong> and <strong>${
      trackingIds[trackingIds.length - 1]
    }</strong> are already added to your track list`;
  },
  deleteError: (trackingIds: string[], nickname: string | null) => {
    if (trackingIds.length === 1) return `Parcel <strong>${nickname ?? trackingIds[0]}</strong> can't be removed.`;
    return `Your selected items can't be removed.`;
  },
  deleteServerError: (trackingIds: string[], nickname: string | null) => {
    if (trackingIds.length === 1)
      return `Parcel <strong>${
        nickname ?? trackingIds[0]
      }</strong> can't be removed right now. Please try again later.`;
    return `Your selected items can't be removed right now. Please try again later.`;
  },
  expiredSession: `Your session expired, so we logged you out to protect your account.`,
  expiredSessionOnRemoveArticle: `Your session expired so we logged you out to protect your account. Log in again to remove this parcel.`,
  articleRedirect: {
    noOwnership: (identifier: string) =>
      `Sorry, the email address linked to ${identifier} doesn't match your MyPost account. To Redirect, you'll need to log in or sign up with the email you gave to the sender. <a href="${extLnkOwnershipFAQ}"target="_blank" style="font-weight:500">Learn more.</a>`,
    noRedirect: `Sorry, Redirect isn't available for this parcel right now.`,
  },
  articleDelegation: {
    expiredLink: (articleId: string) =>
      `Something went wrong. <a href="${extLinkMyPostDelegationUI}${articleId}" target="_blank">Try again</a>.`,
  },
  watchlist: `We can't display your list of tracked items at the moment. Please refresh the page or try again later.`,
  failedToFetchLocation: `Something went wrong. Try again, or <a href="${extLnkPostOfficeLocator}" target="_blank">search for this location manually</a>.`,
};

export const successContent = {
  notification: (trackingIds: string[]) => {
    if (trackingIds.length === 1)
      return `Item added <strong>${trackingIds[0]}</strong> has been added to your tracklist`;
    return `Done. We've added <strong>${trackingIds.slice(0, trackingIds.length - 1).join(', ')}</strong> and <strong>${
      trackingIds[trackingIds.length - 1]
    }</strong> to your track list`;
  },
  articleSubscription: {
    enabled: `You've turned on tracking notifications for this parcel.`,
    disabled: `You've turned off tracking notifications for this parcel.`,
  },
  removeArticleFromTracklist: (trackingIds: string[], nickname: string | null) => {
    return `<span style="font-weight: 500;">${
      trackingIds.length === 1
        ? `'${nickname ?? trackingIds[0]}' has been removed from your list`
        : `${trackingIds.length} parcels have been removed from your list`
    }</span>`;
  },
  removeArticleFromDetails: (trackingIds: string[], nickname: string | null) => {
    return `Parcel <strong>${nickname ?? trackingIds[0]}</strong> was successfully removed`;
  },
};
